<template>
  <div class="container coupon-alt">
    <div class="row">
      <div class="col-12 col-lg-6">
        <div class="coupon-alt_title">
          <p>Укажите промо-код при оформлении заказа</p>
        </div>
      </div>
      <div class="col-12 col-lg-4">
        <div class="coupon-alt_code">
          {{ code }}
        </div>
      </div>
      <div class="col-12 col-lg-2">
        <div @click="copyCode" class="coupon-alt_code_copy">
          <div><font-awesome-icon :icon="['fas', 'copy']" /></div>
          <span>скопировать</span>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    code: {
      type: String,
      default: '',
    },
  },
  methods: {
    copyCode () {
      navigator.clipboard.writeText(this.code)
    },
  },
}
</script>

<style lang="less">
.coupon-alt {
	.row {
		min-height: 130px;
		align-items: center;
		background-color: #F9F9F9;
		padding: 24px 23px;
		border-radius: 24px;

		@media screen and (max-width: 992px) {
			padding-top: 43px;
			padding-bottom: 35px;
			padding-left: 15px;
			padding-right: 15px;
		}
	}

	&_title {
		p {
			font-family: 'Roboto Slab', Arial, sans-serif;
			font-weight: 500;
			font-size: 25px;
			line-height: 30px;

			@media screen and (max-width: 992px) {
				text-align: center;
				margin-bottom: 33px;
			}
		}
	}

	&_code {
		height: 75px;
		display: flex;
		align-items: center;
		justify-content: center;
		background-color: transparent;
		font-family: 'Roboto Slab', Arial, sans-serif;
		font-weight: 500;
		font-size: 49px;
		padding: 0 33px;
		border-radius: 15px;
		border: 1px dashed black;
		position: relative;

		@media screen and (max-width: 1200px) {
			padding: 0 10px;
		}

		@media screen and (max-width: 992px) {
			margin-bottom: 25px;
		}

		&:after {
			content: '';
			width: 29px;
			height: 27px;
			background-image: url('/scisors.png');
			background-size: contain;
			background-repeat: no-repeat;
			position: absolute;
			top: -18px;
			right: 33px;
		}

		&_copy {
			display: flex;
			flex-direction: column;
			align-items: center;
			transition: all .3s;
			cursor: pointer;

			&:hover { transform: scale(1.07); }
			&:active { transform: scale(1); }

			& > div {
				width: 41px;
				height: 41px;
				display: flex;
				align-items: center;
				justify-content: center;
				background-color: white;
				border-radius: 50%;
				box-shadow: 0px 3px 8px rgba(0, 0, 0, 0.1);
				margin-bottom: 2px;
			}

			span {
				font-family: 'Roboto', Arial, sans-serif;
				font-weight: 300;
				font-size: 14px;
				text-align: center;
			}
		}
	}
}
</style>
